function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "37.072%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F0F0F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F0F0F5"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  fillRule: "nonzero",
  stroke: "#BEBFCB",
  d: "M29.435 15.102L15.135.56A.187.187 0 0 0 15 .5c-.05 0-.097.02-.14.065L.566 15.101a.253.253 0 0 0-.048.265.202.202 0 0 0 .184.135h3.745v14.5a1.5 1.5 0 0 0 1.5 1.5h18.106a1.5 1.5 0 0 0 1.5-1.5v-14.5h3.746c.076 0 .15-.05.183-.135a.253.253 0 0 0-.047-.264z",
  transform: "translate(.8)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF8C54",
  d: "M21.8 18.333c0 2.215-1.116 4.16-2.796 5.262l-.204.128v4.719c0 .981-.447 1.499-1.34 1.553L17.3 30h-3c-1 0-1.5-.52-1.499-1.558V23.723c-1.794-1.076-3-3.087-3-5.39 0-1.121 1.387-1.165 1.494-.13l.006.13c0 .907.25 1.752.68 2.468.68 1.172 1.872 2.11 3.573 2.193L15.8 23l.212-.005.041-.001a4.205 4.205 0 0 0 2.948-1.38 4.742 4.742 0 0 0 1.299-3.28l.006-.13c.107-1.036 1.494-.992 1.494.13zM15.8 16c1.243 0 2.25 1.045 2.25 2.333 0 1.289-1.007 2.334-2.25 2.334s-2.25-1.045-2.25-2.334c0-1.288 1.007-2.333 2.25-2.333z"
}));

var SvgAtencaoDomiciliar = function SvgAtencaoDomiciliar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAtencaoDomiciliar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/atencao-domiciliar.1b6b24e7.svg";
export { ForwardRef as ReactComponent };